/*
 * Copyright (c) 2021 SARL SIGMA POLYNESIA
 */

import { stringify } from 'qs'
import rest from '../../../client/js/lib/rest'
import { HalDocument } from '@jalik/hal'

export function deleteUser (id: number) {
  return rest.delete(`/api/users/${id}`)
}

export function fetchUser (id: number): Promise<User> {
  return rest.get(`/api/users/${id}`)
    .then((resp) => resp.json())
}

export function fetchUsers (params?: Record<string, any>): Promise<HalDocument<{ users: User[] }>> {
  const queryParams = stringify(params)
  return rest.get(`/api/users?${queryParams}`)
    .then((resp) => resp.json())
}

export function patchUser (id: number, data: Partial<User>) {
  return rest.patch(`/api/users/${id}`, {
    headers: { 'content-type': 'application/json' },
    body: JSON.stringify(data)
  }).then((resp) => resp.json())
}

export function postUser (data: Partial<User>) {
  return rest.post('/api/users', {
    headers: { 'content-type': 'application/json' },
    body: JSON.stringify(data)
  }).then((resp) => resp.json())
}
